<template>


  <div class="tokens-manager">
    <v-row>
      <v-col class="d-flex justify-center">
        <div class="add-form mt-16">
          <div class="title">
            <v-icon>ico-rfid</v-icon>
            {{ $t('rfid.add-rfid') }}
          </div>


          <div class="btns">
            <v-btn color="success" @click="openEditRfidTag">
              <v-icon left>ico-plus</v-icon>
              {{ $t('add') }}
            </v-btn>
          </div>

        </div>
      </v-col>
      <v-col  class="d-flex justify-center">
        <div class="add-form mt-16">
          <div class="title">
            <v-row>
              <v-col class="d-flex justify-center">
                <v-icon>ico-rfid</v-icon>
                <v-icon class="mx-1">ico-rfid</v-icon>
                <v-icon>ico-rfid</v-icon>
              </v-col>
            </v-row>
            {{ $t('rfid.addMultiple.add') }}
          </div>


          <div class="btns">
            <v-btn color="success" @click="openMultipleRfidModal">
              <v-icon left>ico-plus</v-icon>
              {{ $t('add') }}
            </v-btn>
          </div>

        </div>
      </v-col>
    </v-row>

    <headline bg>
      {{ $tc('rfid.rfid', 2) }}
    </headline>



    <div class="main">

      <v-row class="align-center mb-2">
        <v-col>
          <v-menu
              v-if="selectedItems.length > 0"
              offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="btn-actions-menu"
              >
                {{ $tc('selected-items', selectedItems.length, {count: selectedItems.length})  }}
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <template v-for="(item, index) in actionOptions" >
                <v-divider :key="index" v-if="item.separator"></v-divider>
                <v-list-item
                    dense
                    v-else-if="item.disabled"
                    :key="index"
                    link
                    :ripple="false"
                    class="disabled"
                    @click.stop="item.disabledCallback ? item.disabledCallback() : () => {}"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    :key="index"
                    dense
                    v-else
                    link
                    @click="item.callback ? item.callback() : () => {}"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-col>
        <!-- Dans l'inventaire des badges ou hors inventaire : pour information, pas une alerte -->
        <v-col cols="auto">
          <v-select
              v-model="inventory" :items="inventoryOptions" dense outlined hide-details clearable
              :label="$t('rfid.inventory-filter.label')" style="max-width: 220px"
          />
        </v-col>
        <v-col>
          <search-field v-model="search" clearable></search-field>
        </v-col>
      </v-row>

      <div class="table">
        <v-data-table
            class="rfid-list light"
            v-model="selectedItems"
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :footer-props="{
              itemsPerPageOptions: [
                  10, 20, 50
              ]
            }"
            :options.sync="options"
            show-select
        >
          <template #item.uid="{item}">
            <v-row align="center">
              <v-col style="max-width: 30px;" class="align-self-start">
                <!-- La couleur du badge (lue au stock) en fond, l'icône par-dessus ; son nom en infobulle. Sans couleur : l'icône seule. -->
                <v-tooltip v-if="item.badgeColor && item.badgeColor.hex" bottom>
                  <template #activator="{ on, attrs }">
                    <span class="badge-color" :style="{ background: item.badgeColor.hex }" v-bind="attrs" v-on="on">
                      <v-icon size="16" :color="isLightColor(item.badgeColor.hex) ? 'grey darken-3' : 'white'">ico-rfid</v-icon>
                    </span>
                  </template>
                  <span>{{ item.badgeColor.name }}</span>
                </v-tooltip>
                <v-icon v-else size="20">ico-rfid</v-icon>
              </v-col>
              <v-col>
                <div class="tag token-uid">
                  <router-link v-if="currentUser.isZE" :to="{name:'tokens.detail', params: {id: item.id}}">{{ item.uid }}</router-link>
                  <span v-else>{{ item.uid }}</span>
                  <!-- D'où vient le badge s'il n'est pas du stock : à droite de l'UID, détaché. -->
                  <span class="token-origin"><badge-origin-chip :token="item" /></span>
                </div>
                <div class="ref">{{ item.physicalReference }}</div>
              </v-col>
            </v-row>

          </template>

          <template #item.name="{item}">
            <div class="">
              {{ item.name }}
            </div>
          </template>

          <template #item.customer.lastname="{item}">
            <router-link v-if="item.customer" :to="{name: 'customer.detail', params: {id: item.customer.id}}">
              <template v-if="item.customer.firstname || item.customer.lastname">
                {{ item.customer.firstname }} {{ item.customer.lastname }}
              </template>
              <template v-else>
                {{ item.customer.evcoId }}
              </template>
            </router-link>
            <div v-else>
              -
            </div>
          </template>

          <template #item.member.customer.lastname="{item}">
            <router-link v-if="item.member?.lastname" :to="{name: 'member', params: {memberId: item.member.id}}">
              {{ item.member.firstname }} {{ item.member.lastname }}
            </router-link>
            <div v-else>
              -
            </div>
          </template>

          <template #item.organization.name="{item}">
            <router-link class="organization" v-if="item.organization?.name" :to="{name: 'organizations.detail', params: {id: item.organization.id}}">
              {{ item.organization.name }}
            </router-link>
            <div v-else>
              -
            </div>
          </template>

          <template #item.enabled="{value}">
            <div class="text-center">
              <v-icon color="green" v-if="value">
                mdi-check
              </v-icon>
              <v-icon color="red" v-else>
                mdi-close
              </v-icon>
            </div>
          </template>

          <template #item.vehicle="{item}">
            <div class="text-no-wrap">
              {{ item.vehicle && item.vehicle.registrationNumber ? item.vehicle.registrationNumber : '-' }}
            </div>
          </template>

          <template #item.attributes="{item}">
            <div class="d-flex justify-center align-center" style="gap: 6px;">
              <v-tooltip bottom v-for="attr in tokenAttributes(item)" :key="attr.key">
                <template #activator="{on, attrs}">
                  <v-icon
                      small
                      :color="attr.pending ? 'warning' : attr.active ? attr.color : 'grey lighten-2'"
                      v-on="on"
                      v-bind="attrs"
                  >
                    {{ attr.icon }}
                  </v-icon>
                </template>
                <span v-if="attr.pending">{{ attr.tooltip }} : {{ $t('rfid.professional-consent.pending-short') }}</span>
                <span v-else>{{ attr.tooltip }} : {{ attr.active ? $t('yes') : $t('no') }}</span>
              </v-tooltip>
            </div>
          </template>

          <template #item.lastUsageAt="{item, value}">
            <!-- Badge perso : son activité est privée, le serveur ne l'envoie pas hors de ZEborne. -->
            <v-tooltip v-if="item.privateActivity" top max-width="320">
              <template #activator="{ on, attrs }">
                <span class="text-caption text--secondary text-no-wrap" v-bind="attrs" v-on="on">
                  <v-icon x-small class="mr-1">mdi-lock-outline</v-icon>{{ $t('rfid.private-activity') }}
                </span>
              </template>
              <span>{{ $t('rfid.private-activity-hint') }}</span>
            </v-tooltip>
            <div v-else class="text-no-wrap">
              {{ value|formatDate }}
            </div>
          </template>


          <template #item.options="{item}">
            <div class="options">
              <v-btn icon rounded @click="openEditRfidTag(item)" class="mr-2">
                <v-icon>ico-edit</v-icon>
              </v-btn>
              <v-btn icon rounded @click="deleteRfidCard(item)">
                <v-icon>ico-trash</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>

      </div>
    </div>






    <rfid-form-modal ref="rfidFormModal" @change="onRfidChanged" :customer-id="customerId" :organization-id="organizationId" />

    <badge-withdrawal-dialog v-model="withdrawalDialog" :token="withdrawnToken" @deleted="loadData" />

    <v-dialog v-model="addMultipleRfidsModal" max-width="600">
      <v-form @submit.prevent="addMultipleRfidCards">
        <v-card>
          <v-card-title>
            {{ $t('rfid.addMultiple.add') }}
          </v-card-title>
          <v-card-text>
            <v-row v-if="!addMultipleRfidsResult">
              <v-col>
                <v-textarea
                    :label="$t('rfid.rfid-card-no')"
                    v-model="multipleRfids"
                    outlined
                    rows="10"
                    :placeholder="$t('rfid.addMultiple.rfids-placeholder')"
                    :disabled="addMultipleRfidCardsLoading"
                    :loading="addMultipleRfidCardsLoading"
                />
                <!-- Hors stock, après confirmation : ZEborne les fait entrer, le gestionnaire les déclare externes (sans itinérance) -->
                <v-checkbox
                    v-if="currentUser" v-model="confirmOutOfStock" dense hide-details class="mt-0"
                    :label="$t(currentUser.isZE ? 'rfid.addMultiple.confirm-out-of-stock' : 'rfid.addMultiple.confirm-external')" :disabled="addMultipleRfidCardsLoading"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col>

                <v-alert type="success">{{ $t('rfid.addMultiple.finished')}}</v-alert>


                <div>
                  <span class="green--text">{{ $t('rfid.addMultiple.added') }} : <b>{{ addMultipleRfidsResult.added.length }}</b></span>
                  <div style="font-size: 11px;" v-if="addMultipleRfidsResult.added.length > 0">{{ addMultipleRfidsResult.added.join(', ') }}</div>
                </div>

                <v-divider class="my-4"></v-divider>

                <div>
                  <span class="orange--text">{{ $t('rfid.addMultiple.duplicated') }} : <b>{{ addMultipleRfidsResult.duplicated.length }}</b></span>
                  <div style="font-size: 11px;" v-if="addMultipleRfidsResult.duplicated.length > 0">{{ addMultipleRfidsResult.duplicated.join(', ') }}</div>
                </div>

                <v-divider class="my-4"></v-divider>

                <div>
                  <span  class="red--text">{{ $t('rfid.addMultiple.invalid') }} : <b>{{ addMultipleRfidsResult.invalid.length }}</b></span>
                  <div style="font-size: 11px;" v-if="addMultipleRfidsResult.invalid.length > 0"> {{ addMultipleRfidsResult.invalid.join(', ') }}</div>
                </div>

                <template v-if="(addMultipleRfidsResult.refused || []).length">
                  <v-divider class="my-4"></v-divider>
                  <div>
                    <span class="red--text">{{ $t('rfid.addMultiple.refused') }} : <b>{{ addMultipleRfidsResult.refused.length }}</b></span>
                    <div v-for="refused in addMultipleRfidsResult.refused" :key="refused.uid" style="font-size: 11px;">{{ refused.uid }} — {{ refused.message || refused.reason }}</div>
                  </div>
                </template>

              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions>
            <v-row class="ma-0" v-if="!addMultipleRfidsResult">
              <v-col class="text-right">
                <v-btn text type="button" class="mr-3" @click="addMultipleRfidsModal = false" :disabled="addMultipleRfidCardsLoading">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn color="primary" type="submit" :disabled="addMultipleRfidCardsLoading">
                  {{ $t('add') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row  v-else>
              <v-col class="text-right">
                <v-btn text type="button" class="mr-3" @click="addMultipleRfidsModal = false" :disabled="addMultipleRfidCardsLoading">
                  {{ $t('close') }}
                </v-btn>
              </v-col>
            </v-row>

          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import RfidFormModal from "@modals/RfidFormModal.vue";
import BadgeOriginChip from "@elements/BadgeOriginChip.vue";
import BadgeWithdrawalDialog from "@elements/BadgeWithdrawalDialog.vue";
import RulesMixin from "@mixins/RulesMixin";
import TokenRepository from "@repository/TokenRepository";
import tokenRepository from "@repository/TokenRepository";

export default {

  components: {
    RfidFormModal, BadgeOriginChip, BadgeWithdrawalDialog
  },

  data() {
    return {
      search: null,
      addMultipleRfidsModal: false,
      tokens: [],
      options: null,
      total: 0,
      rfidForm: {
        uid: null,
        name: null,
        physicalReference: null,
        enabled: null,
      },
      addRfidTagLoading: false,
      deleteRfidTagLoading: false,
      multipleRfids: null,
      addMultipleRfidCardsLoading: false,
      addMultipleRfidsResult: null,
      inventory: null,
      confirmOutOfStock: false,
      withdrawnToken: null,
      withdrawalDialog: false,
      selectedItems: [],
    }
  },

  props: {
    memberId: {type: String, default: null},
    customerId: {type: String, default: null},
    organizationId: {type: String, default: null},
  },

  mixins: [
    RulesMixin,
  ],

  mounted() {

  },

  watch: {
    options() {
      this.loadData()
    },

    search() {
      this.loadData()
    },

    inventory() {
      this.loadData()
    },
  },

  computed: {
    inventoryOptions() {
      return [
        { value: 'in', text: this.$t('rfid.inventory-filter.in') },
        { value: 'out', text: this.$t('rfid.inventory-filter.out') },
      ]
    },

    actionOptions() {

      return [
        {
          text: this.$t('rfid.action-multiple-enable'),
          value: 'enable',
          callback: () => {
            this.showLoading(true)
            tokenRepository.actionForMultipleRfid('enable', this.selectedItems.map(i => i.id)).then(() => {
              this.selectedItems = []
              this.loadData()
            }).catch(err => {
              this.showLoading(false)
              this.notifyError(err)
            })
          }
        },
        {
          text: this.$t('rfid.action-multiple-disable'),
          value: 'disable',
          callback: () => {
            this.showLoading(true)
            tokenRepository.actionForMultipleRfid('disable', this.selectedItems.map(i => i.id)).then(() => {
              this.selectedItems = []
              this.loadData()
            }).catch(err => {
              this.showLoading(false)
              this.notifyError(err)
            })
          }
        },
      ]
    },

    headers() {
      const headers =  [
        {text: this.$t('rfid.rfid-card-no'), value: "uid", align: 'left'},
        {text: this.$t('rfid.rfid-card-name'), value: "name", align: 'left'},
        {text: this.$t('vehicle-registration'), value: "vehicle", align: 'left', sortable: false},
        {text: this.$t('rfid.attributes'), value: "attributes", align: 'center', sortable: false},
        {text: this.$t('last-usage'), value: "lastUsageAt", align: 'left'},
        {text: this.$t('rfid.rfid-card-enabled'), value: "enabled", align: 'center'},
        {text: "", value: "options", sortable: false},
      ]

      if(!this.organizationId && !this.customerId) {
        headers.splice(1, 0, ...[
          {text: this.$tc('customer.customer'), value: "customer.lastname", align: 'left'},
          {text: this.$t('organization.organization'), value: "organization.name", align: 'left'},
        ])
      } else if(this.organizationId && !this.customerId) {
        headers.splice(1, 0, ...[
          {text: this.$tc('member.member', 1), value: "member.customer.lastname", align: 'left'},
        ])
      } else if(!this.organizationId && this.customerId) {
        headers.splice(1, 0, ...[
          {text: this.$t('organization.organization'), value: "organization.name", align: 'left'},
        ])
      }
      return headers
    },


    items() {
      return this.tokens || []
    },

  },

  methods: {
    /** Un fond clair (blanc, jaune…) : l'icône y passe en foncé, sinon elle disparaît. */
    isLightColor(hex) {
      const [r, g, b] = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16))
      return (0.299 * r + 0.587 * g + 0.114 * b) > 186
    },

    tokenAttributes(item) {
      const attrs = [
        // Coché pro, en attente de l'accord de la personne : il reste personnel jusque-là.
        { key: 'corporate', active: !!item.corporate, pending: !item.corporate && !!item.professionalRequest, icon: 'mdi-domain', color: 'primary', tooltip: this.$t('rfid.rfid-corporate') },
        { key: 'private', active: !!item.private, icon: 'mdi-account-plus-outline', color: 'primary', tooltip: this.$t('rfid.third-party') },
      ]
      if (this.currentUser.isZE) {
        attrs.push({ key: 'roaming', active: !!item.roaming, icon: 'mdi-earth', color: 'primary', tooltip: this.$t('roaming') })
        attrs.push({ key: 'orgPayment', active: !!item.organizationPaymentMethod, icon: 'mdi-cash', color: 'primary', tooltip: this.$t('rfid.paid-by-organization') })
      }
      return attrs
    },

    loadData() {
      return new Promise((resolve) => {
        let searchText = this.search;
        let offset = this.options.itemsPerPage * this.options.page - this.options.itemsPerPage;
        let limit = this.options.itemsPerPage;
        let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : 'createdAt'
        let sortOrder = this.options.sortDesc.length > 0 && this.options.sortDesc[0] ? 'desc' : 'asc'


        this.showLoading(true)

        const data = {
          searchText,
          offset,
          limit,
          sortBy,
          sortOrder,
        }

        if(this.customerId) {
          data.customerId = this.customerId
        }

        if(this.memberId) {
          data.memberId = this.memberId
        }

        if(this.organizationId) {
          data.organizationId = this.organizationId
        }

        if(this.inventory) {
          data.inInventory = this.inventory === 'in'
        }

        TokenRepository.search(data).then(data => {
          this.tokens = data.items
          this.total = data.total
          this.showLoading(false)
          resolve()
        }).catch(err => {
          this.notifyError(err)
          this.showLoading(false)
        })
      })
    },

    openMultipleRfidModal() {
      this.multipleRfids = null;
      this.addMultipleRfidsResult = null;
      this.confirmOutOfStock = false;
      this.addMultipleRfidsModal = true;
    },

    addMultipleRfidCards() {
      if (this.multipleRfids?.trim()) {
        this.addMultipleRfidCardsLoading = true;

        const data = {
          uids: this.multipleRfids.split(/[\n;, ]+/).filter(i => i.trim()).map(i => i.trim()),
          confirmOutOfStock: this.confirmOutOfStock,
        }

        if(this.customerId) {
          data.customerId = this.customerId
        }

        if(this.memberId) {
          data.memberId = this.memberId
        }

        if(this.organizationId) {
          data.organizationId = this.organizationId
        }

        TokenRepository.createMultiple(data).then((response) => {
          this.addMultipleRfidsResult = response
          this.loadData().then(() => {
            this.addMultipleRfidCardsLoading = false;
          })
        }).catch(err => {
          this.notifyError(err)
          this.addMultipleRfidCardsLoading = false;
        })
      }
    },

    onRfidChanged() {
      this.loadData()
    },

    openEditRfidTag(item) {
      this.$refs.rfidFormModal.open({rfidId: item?.id})
    },


    /** Un badge du stock : on dit ce qu'il devient (fenêtre) ; un autre (tiers, origine inconnue) : simple confirmation. */
    deleteRfidCard(item) {
      if (item.inInventory) {
        this.withdrawnToken = item
        this.withdrawalDialog = true
        return
      }
      const id = item.id
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if (result) {
          this.showLoading(true)
          this.deleteRfidTagLoading = true
          TokenRepository.delete(id).then(() => {
            this.loadData().then(() => {
              this.deleteRfidTagLoading = false
              this.showLoading(false)
            })
          }).catch(err => {
            this.notifyError(err)
            this.showLoading(false)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* L'UID et son étiquette d'origine côte à côte ; si la colonne est trop étroite, l'étiquette passe dessous, alignée à gauche. */
.tokens-manager .token-uid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 10px;
}
.tokens-manager .token-origin {
  white-space: nowrap;
}

.tokens-manager {
  & > .main {
    .table {
      tr {
        td {
          a {
            font-size: 14px;
          }
        }
      }

      .tag {
        color: black;
        .v-icon {
          margin-right: 40px;
        }
      }

      .name {
        color: var(--v-primary-base);
      }

      .ref {
        color: #3b3b3b;
        font-size: 14px;
        font-weight: 400;
      }

      .badge-color {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        margin-left: -3px;
        border-radius: 6px;
        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
        .v-icon {
          margin-right: 0;
        }
      }


      .options {
        .v-btn--icon {
          border: 1px solid #758093;
          width: 30px;
          height: 30px;
          i {
            font-size: 16px;
            color: #758093;
          }
        }
      }
    }
  }

  .add-form {
    position: relative;
    margin: 30px 0 60px 30px;
    background-color: #fff;
    border: 1px solid var(--v-primary-base);
    padding: 20px 20px 50px 20px;
    border-radius: 15px;
    color: #758093;
    width: 400px;
    text-transform: uppercase;

    .title {
      text-align: center;
      color: var(--v-primary-base);
      font-weight: bold;

      i {
        color: var(--v-primary-base);
        display: block;
      }
    }

    .v-text-field {
      box-shadow: 0 10px 30px #00000029;

      .v-input__slot {
        border-color: #75809340;
      }
    }

    .btns {
      text-align: center;
      position: absolute;
      left: 20px;
      right: 20px;
      bottom: -30px;
      font-size: 22px;
    }
  }

}

.v-list {
  .v-list-item {
    &.disabled {
      .v-list-item__title {
        cursor: not-allowed;
        color: rgba(0, 0, 0, 0.38) !important;
      }
    }
  }
}

</style>
